import { ReactNode } from 'react';
import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { trackBadgeCardClick } from 'analytics/profileAnalytics';

interface Props {
  isClickable: boolean;
  children: ReactNode;
  to?: string;
  badgeTitle: string;
  badgeType?: 'learning' | 'forums';
  isPersonalView?: boolean;
}

export const BadgeCardWrapper = ({
  isClickable,
  children,
  to = '#',
  badgeTitle,
  badgeType = 'forums',
  isPersonalView = false,
}: Props) => {
  if (!isClickable) {
    return <div css={notClickableContainerStyles}>{children}</div>;
  }

  const onClickCard = () => {
    trackBadgeCardClick(badgeTitle, badgeType, isPersonalView);
  };

  return (
    <a
      css={containerStyles}
      onClick={onClickCard}
      href={to}
      target="_blank"
      rel="noreferrer"
    >
      {children}
    </a>
  );
};

const containerStyles = css({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  borderRadius: '4px',
  padding: '16px 12px',
  boxShadow: token('elevation.shadow.raised'),
  textDecoration: 'none',
  color: 'inherit',
  transition: 'box-shadow 0.2s ease',
  '&:hover': {
    cursor: 'pointer',
    boxShadow: token('elevation.shadow.overlay'),
    textDecoration: 'none',
    color: 'inherit',
  },

  '&:active': {
    border: `2px solid ${token('color.border.selected')}`,
  },
});

const notClickableContainerStyles = css({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  borderRadius: '4px',
  padding: '16px 12px',
  border: `1px solid ${token('color.border')}`,
});
